import { Button, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { supabase } from "../../../config/supabaseClient";

const ManageLinksModal = (props: any) => {
  const { selectedPost, user_id, username, linksModal, refetchData } = props;
  const [newPermalink, setNewPermalink] = useState("");
  const [newShoplink, setNewShoplink] = useState("");
  const [newTaggedLink, setNewTaggedLink] = useState("");
  const [newExternalLink, setNewExternalLink] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    const fetchLinks = async () => {
      if (selectedPost && selectedPost.post_id) {
        try {
          const { data, error } = await supabase
            .from(`${username}`)
            .select("*")
            .eq("post_id", selectedPost.post_id)
            .eq("user_id", user_id);
          const { data: product, error: productError } = await supabase
            .from("product_bank")
            .select("*")
            .eq("product_id", selectedPost.post_id)
            .eq("user_id", user_id);
          if (error) {
          } else if (data && data.length > 0) {
            // Assuming data is an array and we're interested in the first item
            const fetchedData = data[0];
            setNewPermalink(fetchedData.permalink);
            setNewShoplink(fetchedData.shop_link);
            setNewTaggedLink(fetchedData.tagged_link);
            setNewExternalLink(fetchedData.external_link);
          } else {
            if (product && product.length > 0) {
              // Assuming product is an array and we're interested in the first item
              const fetchedData = product[0];
              setNewPermalink(fetchedData.permalink);
              setNewShoplink(fetchedData.url);
              setNewTaggedLink(fetchedData.tagged_link);
              setNewExternalLink(fetchedData.external_link);
            }
          }
        } catch (err) {}
      }
    };

    fetchLinks(); // Call fetchLinks inside useEffect
  }, [selectedPost, linksModal]);
  // Check if any of the fields have changed
  useEffect(() => {
    const hasChanges =
      newPermalink !== selectedPost?.permalink ||
      newShoplink !== selectedPost?.shop_link ||
      newTaggedLink !== selectedPost?.tagged_link ||
      newExternalLink !== selectedPost?.external_link;

    setIsChanged(hasChanges);
  }, [newPermalink, newShoplink, newTaggedLink, newExternalLink, selectedPost]);

  async function handleLinksOk() {
    try {
      setConfirmLoading(true);
      const updatedPost = {
        ...selectedPost,
        permalink: newPermalink,
        shop_link: newShoplink,
        tagged_link: newTaggedLink,
        external_link: newExternalLink,
      };

      // Update content_new table
      const { error: cerrr } = await supabase
        .from("content_new")
        .update({
          permalink: newPermalink,
          shop_link: newShoplink,
          tagged_link: newTaggedLink,
          external_link: newExternalLink,
        })
        .eq("post_id", selectedPost.post_id)
        .eq("user_id", user_id);

      if (cerrr) throw cerrr;

      // Update user table
      const { error: uerrr } = await supabase
        .from(`${username}`)
        .update({
          permalink: newPermalink,
          shop_link: newShoplink,
          tagged_link: newTaggedLink,
          external_link: newExternalLink,
        })
        .eq("post_id", selectedPost.post_id)
        .eq("user_id", user_id);

      if (uerrr) throw uerrr;

      props.setSelectedPost(updatedPost);
      await props.refetchData();
      
      // Reset form
      setNewPermalink("");
      setNewShoplink("");
      setNewTaggedLink("");
      setNewExternalLink("");
      
      // Close modal
      props.setLinksModal(false);
    } catch (error) {
      console.error("Error updating links:", error);
    } finally {
      setConfirmLoading(false);
    }
  }

  async function handleLinksCancel() {
    props.setLinksModal(false);
    setNewPermalink("");
    setNewShoplink("");
    setNewTaggedLink("");
    setNewExternalLink("");
  }

  return (
    <>
      <Modal
        open={linksModal}
        onOk={handleLinksOk}
        onCancel={handleLinksCancel}
        style={{
          overflowY: "auto",
          maxHeight: "90vh",
        }}
        confirmLoading={confirmLoading}
        focusTriggerAfterClose={false}
        getContainer={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={handleLinksOk}
            disabled={!isChanged} // Disable button if no changes
            id="manage-link-save"
            loading={confirmLoading}
          >
            Save
          </Button>,
        ]}
      >
        <>
          <h5 className="text-center mb-4 fontsize-16">Manage Links</h5>

          <label className="bold-label fontsize-12">Source Link</label>
          <Input
            value={newPermalink}
            onChange={(e: any) => setNewPermalink(e.target.value)}
            placeholder="enter source link here"
            className="mb-20"
            id="enter-permalink"
          />

          <label className="bold-label fontsize-12">Link to Tagged Account</label>
          <Input
            value={newTaggedLink}
            onChange={(e: any) => setNewTaggedLink(e.target.value)}
            placeholder="enter tagged link here"
            className="mb-20"
          />

          <label className="bold-label fontsize-12">Shop Link</label>
          <Input
            value={newShoplink}
            onChange={(e: any) => setNewShoplink(e.target.value)}
            placeholder="enter shop link here"
            className="mb-20"
            id="enter-shoplink"
          />

          <label className="bold-label fontsize-12">External Link</label>
          <Input
            value={newExternalLink}
            onChange={(e: any) => setNewExternalLink(e.target.value)}
            placeholder="enter external link here"
            className="mb-20"
          />
        </>
      </Modal>
    </>
  );
};

export default ManageLinksModal;
